import { useCallback, useState } from 'react';
import type { SendbirdFileMessage } from '@sendbird/uikit-utils';
import type { TChatMedia } from '../types';

export const useChatMediaViewer = () => {
    const [media, setMedia] = useState<TChatMedia | null>(null);

    const openMedia = useCallback((message: SendbirdFileMessage, _deleteMessage: () => Promise<void>, uri: string) => {
        if (!uri) return;
        setMedia({ uri, isImage: (message.type ?? '').startsWith('image/') });
    }, []);

    const closeMedia = useCallback(() => setMedia(null), []);

    return { media, openMedia, closeMedia };
};
